import styled from "@emotion/styled"

export const StyledAnchor = styled("div")(({theme}) => ({
    display: "block",
    visibility: "hidden",
    position: "relative",
}))